module.exports = __webpack_public_path__ + "static/chunks/src/components/part-footer/assets/logo-vissa-footer.ba2ee2938b38109a0bb92e6e00a2e361.webp";